"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Panel = void 0;

var _Collapse = _interopRequireDefault(require("./Collapse"));

var _default = _Collapse.default;
exports.default = _default;
var Panel = _Collapse.default.Panel;
exports.Panel = Panel;


//////////////////
// WEBPACK FOOTER
// ./~/rc-collapse/lib/index.js
// module id = 817
// module chunks = 0